module.exports = __webpack_public_path__ + "media/images/flags/CD-d18f895ec4b9eca06959261ddca398c6.svg";